import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const AuthorNameWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0.4rem 0;
  font-size: 13px;
  color: ${({ theme }) => theme.default.color.text.dark};
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  a {
    color: ${({ theme }) => theme.default.color.text.dark};
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    :hover {
      text-decoration: underline;
    }
  }
  p {
    font-size: 13px;
    margin: 0;
  }
`;
